module.exports = __webpack_public_path__ + "img/bgImg.67988d53.png";